import {
  Documents,
  SendDocumentsClientRequest,
} from '../../../@types/SendDocumentsByEmail'
import { useProgressStore } from '../../../Stores/progressStore'
import { useSimulatorStore } from '../../../Stores/simulatorStore'
import { usePolicyholderDetailsStore } from '../../../Stores/policyholderDetailsStore'
import { useCreateProposalStore } from '../../../Stores/useCreateProposalStore'
import { useEntityDetailsForSummaryDocumentStore } from '../../../Stores/useEntityDetailsForSummaryDocumentStore'
import { useGenerateProposalDocumentsStore } from '../../../Stores/useGenerateProposalDocumentsStore'
import { useGetAdditionalEntityDetailsStore } from '../../../Stores/useGetAdditionalEntityDetailsStore'
import { useRunPetisSimulationStore } from '../../../Stores/useRunPetisSimulationStore'
import { useSimulationSummaryDownloadStore } from '../../../Stores/useSimulationSummaryDownloadStore'
import { removeDuplicatesDocuments } from '../../../utils/validates'

export const useSendDocumentsByEmailPayload = () => {
  const { createProposal } = useCreateProposalStore()
  const { entitySelected } = useSimulatorStore()
  const { policyholderDetailsSelected } = usePolicyholderDetailsStore()
  const { entityDetailsForSummaryDocumentSelected } =
    useEntityDetailsForSummaryDocumentStore()
  const { policyholderAdditionalDetails } = useGetAdditionalEntityDetailsStore()
  const { simulationSummaryDownload } = useSimulationSummaryDownloadStore()
  const { generateProposalDocuments } = useGenerateProposalDocumentsStore()
  const { runPetisSimulation } = useRunPetisSimulationStore()

  const { currentStep } = useProgressStore()

  const convertDocuments = () => {
    const documents =
      generateProposalDocuments?.documentstoList ||
      simulationSummaryDownload?.documentsToList ||
      []

    const uniqueDocuments = removeDuplicatesDocuments(documents, 'keyRef')

    const newDocuments: Documents[] = uniqueDocuments.map((item) => ({
      idExternal: item.documentExternalId,
      keyRef: item.keyRef,
      managementSystemCode: item.managementSystemCode,
      name: `${item?.documentName?.trim()}.pdf`,
      documentId: item.documentExternalId,
    }))
    return newDocuments
  }

  const payload: SendDocumentsClientRequest = {
    fromEmail: '', //TODO: Verify witch email to use
    documents: convertDocuments(), //TODO:
    recipientEmail:
      policyholderAdditionalDetails?.emailContact?.email ||
      entityDetailsForSummaryDocumentSelected?.email ||
      '',
    clientName:
      entitySelected?.name ||
      entityDetailsForSummaryDocumentSelected?.name ||
      policyholderDetailsSelected?.name ||
      '',
    simulationId: runPetisSimulation?.runPetisSimulationResponse?.quoteId || '',
    policyId:
      currentStep === 2
        ? ''
        : createProposal?.createProposalResponse?.proposalId,
  }

  return payload
}
